import { Grid, ListItem, Typography } from '@deere/fuel-react';
import { DateTime } from 'luxon';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './EmployeeInfo.module.css';

const groupByPostingStartDate = (objectArray, property) => {
    return objectArray.reduce((acc, obj) => {
        const key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
};

const EmpJobBidRow = ({ empJobBid }) => {
    const navigate = useNavigate();
    return (
        <ListItem
            onClick={() => {
                const isActiveJob =
                    DateTime.now().toISODate() <
                    DateTime.fromISO(empJobBid.endDate).toFormat('yyyy-LL-dd');
                const jobDetailPageUrl = isActiveJob
                    ? '/active-jobs/'
                    : '/closed-jobs/';
                navigate(jobDetailPageUrl + empJobBid.jobNumber);
            }}
            className={styles.jobBidRow}
        >
            <Grid container className={styles.jobBidRowInner}>
                <Grid item sm={0.5} xs={0.5} className={styles.center}>
                    <Typography fontWeight="400" variant="h1">
                        {empJobBid.empPreference}
                    </Typography>
                </Grid>
                <Grid container item xs={11.5}>
                    <Grid item sm={6} className={styles.jobBidRowTitle}>
                        <span>
                            {empJobBid.jobClassification} #{empJobBid.jobNumber}{' '}
                        </span>
                        <span>- ({empJobBid.openings}) openings</span>
                    </Grid>
                    <Grid item sm={2}>
                        {empJobBid.adminRank !== 0 && (
                            <Typography fontWeight="bold" variant="h5">
                                Ranked {empJobBid.adminRank} out of{' '}
                                {empJobBid.totalBidders} bidders
                            </Typography>
                        )}
                    </Grid>
                    <Grid item sm={4} className={styles.jobBidStatus}>
                        <span>{empJobBid.bidStatus}</span>
                    </Grid>
                    <Grid item xs={12} className={styles.jobBidInfoSection}>
                        <span>Facility: {empJobBid.facility}</span>
                        <span>Department: {empJobBid.jobDept}</span>
                        <span>Job Grade: {empJobBid.jobGrade}</span>
                        <span>
                            Bid Close{' '}
                            {empJobBid.endDate
                                ? DateTime.fromISO(empJobBid.endDate).toFormat(
                                      'LL/dd/yy'
                                  )
                                : ''}
                        </span>
                    </Grid>
                </Grid>
            </Grid>
        </ListItem>
    );
};

export const CurrentBidHistoryView = ({ bids }) => {
    const bidsGroupedByPostingStartDate = groupByPostingStartDate(
        bids,
        'postingStartDate'
    );
    return (
        <>
            {Object.entries(bidsGroupedByPostingStartDate).map(
                ([key, values]) => (
                    <Grid container key={key}>
                        <Grid item sm={12} style={{ paddingBottom: '1rem' }}>
                            <Typography variant="h3" className={styles.heading}>
                                Bid Cycle{' '}
                                {DateTime.fromISO(key).toLocaleString(
                                    DateTime.DATE_MED
                                )}{' '}
                                -{' '}
                                {DateTime.fromISO(
                                    values[0].withDrawalEndDate
                                ).toLocaleString(DateTime.DATE_MED)}
                            </Typography>
                        </Grid>
                        <Grid
                            container
                            spacing={4}
                            className={styles.bidGridSection}
                        >
                            <Grid item sm={12}>
                                <Typography
                                    fontWeight="semibold"
                                    variant="h4"
                                    color="#367C2B"
                                >
                                    Rankings ({values.length})
                                </Typography>
                            </Grid>
                            {values.map((eachRow) => (
                                <EmpJobBidRow
                                    key={eachRow.jobNumber}
                                    empJobBid={eachRow}
                                />
                            ))}
                        </Grid>
                    </Grid>
                )
            )}
        </>
    );
};
